/* eslint-disable @typescript-eslint/no-use-before-define */
import { changeBreadCrumbAction, DatePicker, ColumnInfo, DetailsList, FileInfo, FileSelector, FileSelectorMode, LayoutContent, MessageBar, Section, SectionSize, VirtualizedComboBox, ApiException } from '@eta/components';
import { ActionButton, DetailsListLayoutMode, IComboBoxOption, Icon, IIconProps, MessageBarType, PrimaryButton, SelectionMode, Spinner, SpinnerSize, TextField } from '@fluentui/react';
import clsx from 'clsx';
import React, { FC, Fragment, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { ReduxState } from '../../common/reducers';
import { FormModel } from '../../helpers/FormModel';
import { NumberOfShimmerLines, UIHelpers } from '../../helpers/UIHelpers';
import { ServiceCreator } from '../Service/client';
import { MaxAttachmentLimitInMB } from '../Service/constants';
import { ApplicationAttachment, Countries } from '../Service/Model';
import { AddressDto, ApplicationAttachmentDto, ApplicationTypes, SubmitApplicationRequestDto } from '../Service/proxy';
import { GetTaxpayerAddressDto, GetTaxpayerByRinResponseDto, LookupsDto, GetCurrentTaxpayerResponseDto, IGetLookupResponse } from '../Service/TaxpayerProxy';
import '../Styles/Application.scss';

interface Ilookups {

    countries?: IComboBoxOption[] | undefined;

    cities?: IComboBoxOption[] | undefined;

    governorates?: IComboBoxOption[] | undefined;

}
const pencilIcon: IIconProps = { iconName: 'Edit' };
const emptyProfile = new GetCurrentTaxpayerResponseDto();

const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
    currentTaxpayerProfile: state.taxpayerProfile.currentTaxpayerProfile ?? emptyProfile,
    IsRenew: state.Intermediary.IsRenew

});

const mapDispatchToProps = {
    dispatchChangeBreadcrumb: changeBreadCrumbAction
};


const connector = connect(mapStateToProps, mapDispatchToProps);
type ApplicationProps = ConnectedProps<typeof connector>;

const Application: FC<ApplicationProps> = (props: ApplicationProps) => {
    const [onLoadDataComplete, setOnLoadDataComplete] = useState<boolean>(false);
    const { currentLanguage, dispatchChangeBreadcrumb, currentTaxpayerProfile, IsRenew } = props;
    const { t } = useTranslation(['application', 'common']);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [exceptionMessage, setExceptionMessage] = useState<string | undefined>();
    const [businessErrors, setBusinessErrors] = useState<string | undefined>();
    const [taxpayer, setTaxpayer] = useState<GetTaxpayerByRinResponseDto | undefined>();
    const [lookups, setLookups] = useState<Ilookups | undefined>();
    const [countryID, setCountryID] = useState<number>();
    const [governorateID, setGovernorateID] = useState<number>();
    const [cityID, setCityID] = useState<number>();
    const [streetName, setStreetName] = useState<string | undefined>();
    const [buildingNo, setBuildingNo] = useState<string | undefined>();
    const [flatNo, setFlatNo] = useState<string | undefined>();
    const [floorNo, setFloorNo] = useState<string | undefined>();
    const [postalCode, setPostalCode] = useState<string | undefined>();
    const [additionalInformation, setAdditionalInformation] = useState<string | undefined>();
    const [streetName2, setStreetName2] = useState<string | undefined>();
    const [isValid, setIsValid] = useState<boolean | undefined>(false);
    const [isApplied, setIsApplied] = useState<boolean | undefined>(false);
    const [mobileNo, setMobileNo] = useState<string | undefined>();
    const [url, seturl] = useState<string | undefined>();
    const [email, setemail] = useState<string | undefined>();
    const [description, setdescription] = useState<string | undefined>();
    const [activeFrom, setActiveFrom] = useState<Date | undefined>(new Date());
    const [activeTo, setActiveTo] = useState<Date | undefined | null>(undefined);
    const formModel = useRef(new FormModel(setIsValid));
    const form = formModel.current;
    const [foreignGovernorateName, setForeignGovernorateName] = useState<string | undefined>();
    const [foreignCityName, setForeignCityName] = useState<string | undefined>();
    const [taxpayerAddress, setTaxpayerAddress] = useState<GetTaxpayerAddressDto | undefined>();
    const [columns, setColumns] = useState<ColumnInfo[]>();
    const [changeAddress, setChangeAddress] = useState<boolean>(false);
    const [allcities, setCities] = useState<LookupsDto[] | undefined>();
    const [governorateCode, setgovernorateCode] = useState<string | undefined>();
    const [intermediaryId, setIntermediaryId] = useState<number>();
    const [sourceAddress, setSourceAddress] = useState<string | undefined>();
    const [intermidearyAddress, setIntermidearyAddress] = useState<string>();



    const today = new Date();

    const inputsClassName = clsx(
        'inputClass',
        changeAddress && 'change',
    );
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.tiff|\.pdf)$/i;
    const maxNumberOfFiles = 10;
    const cancellationToken = useRef<boolean>(false);
    const [fileError, setFileError] = useState<
        string | undefined
    >();
    const [applicationAttachments, setApplicationAttachments] = useState<ApplicationAttachment[]>([]);
    const history = useHistory();
    function _base64ToArrayBuffer(base64: string) {
        const binarystring = window.atob(base64);
        const len = binarystring.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i += 1) {
            bytes[i] = binarystring.charCodeAt(i);
        }
        return bytes.buffer;
    }
    const handleException = (Error: ApiException): void => {

        const errors = UIHelpers.GetCurrentErrors(Error.message, Error.status, Error.serviceError?.details);

        setExceptionMessage(errors?.ExceptionMessage);
        setBusinessErrors(errors?.BusinessErrors ?? errors?.TaxpayerId ?? errors?.IntermediaryId ?? errors?.Status ?? errors?.Note ??
            errors?.Address ?? errors?.ApplicationAttachments ?? errors?.FileName ?? errors?.FileType ?? errors?.FileContent ??
            errors?.ApplicationId ?? errors?.ApplicationStatus ?? errors?.Note ?? Error.serviceError?.toString());


        if (errors) {
            form.UpdateFieldWithError('streetName', errors['Address.StreetName']);
            form.UpdateFieldWithError('countryID', errors['Address.CountryID']);
            form.UpdateFieldWithError('governorateID', errors['Address.GovernorateID']);
            form.UpdateFieldWithError('cityID', errors['Address.CityID']);
            form.UpdateFieldWithError('postalCode', errors['Address.PostalCode']);
            form.UpdateFieldWithError('additionalInformation', errors['Address.AdditionalInformation']);
            form.UpdateFieldWithError('streetName2', errors['Address.StreetName2']);
            form.UpdateFieldWithError('email', errors?.Email);
            form.UpdateFieldWithError('mobileNo', errors?.MobileNo);
            form.UpdateFieldWithError('url', errors?.URL);
            form.UpdateFieldWithError('description', errors?.ApplicationDescription);
            form.UpdateFieldWithError('buildingNo', errors['Address.BuildingNo']);
            form.UpdateFieldWithError('ActiveFrom', errors?.ActiveFrom);
            form.UpdateFieldWithError('ActiveTo', errors?.ActiveTo);
            form.UpdateFieldWithError('foreignGovernorateName', errors['Address.ForeignGovernorateName']);
            form.UpdateFieldWithError('foreignCityName', errors['Address.ForeignCityName']);


        }



    };

    const getFormatedAdress = (address: AddressDto | undefined, lookupsResponse: IGetLookupResponse | undefined) => {
        let formatedAddress = '';
        const country = lookupsResponse?.countries?.find(c => c.id === address?.countryID);
        const governorate = lookupsResponse?.governorates?.find(g => g.id === address?.governorateID);
        const city = lookupsResponse?.cities?.find(c => c.id === address?.cityID);

        if (currentLanguage?.langIso4.startsWith('ar')) {
            formatedAddress = (address?.countryID === Countries.Egypt) ? `${country?.name},${governorate?.name},${city?.name},${address?.buildingNo} ${address?.streetName},${address?.flatNo ?? ''},${address?.floorNo ?? ''}` :
                `${country?.name},${address?.foreignGovernorateName},${address?.foreignCityName},${address?.buildingNo} ${address?.streetName},${address?.flatNo ?? ''},${address?.floorNo ?? ''}`;

        } else {
            formatedAddress = (address?.countryID === Countries.Egypt) ? `${address?.flatNo ?? ''},${address?.floorNo ?? ''},${address?.buildingNo} ${address?.streetName},${city?.name},${governorate?.name},${country?.name}` :
                `${address?.flatNo ?? ''},${address?.floorNo ?? ''},${address?.buildingNo} ${address?.streetName},${address?.foreignCityName},${address?.foreignGovernorateName},${country?.name}`;

        }

        return formatedAddress;
    };


    const getIntermideary = async (lookupsResponse: IGetLookupResponse | undefined) => {

        try {
            setIsLoading(true);

            const client = ServiceCreator.getProviderManagementPublicClient();
            const response = await client.getDetails();
            if (response) {
                setIsApplied(true);
                setTaxpayer(response.taxpayer);
                setIntermediaryId(response?.id);
                const taxPayerAddress = response?.address;
                // eslint-disable-next-line no-use-before-define
                IsValidData(taxPayerAddress);

                const formatAddress = getFormatedAdress(taxPayerAddress, lookupsResponse);
                setIntermidearyAddress(formatAddress);
                setemail(response.email);
                setMobileNo(response.mobileNo);
                seturl(response.url);
                setCountryID(taxPayerAddress?.countryID);

                if (taxPayerAddress?.countryID === Countries.Egypt) {

                    setGovernorateID(taxPayerAddress?.governorateID);
                    setCityID(taxPayerAddress?.cityID);
                } else {
                    setForeignGovernorateName(taxPayerAddress?.foreignGovernorateName);
                    setForeignCityName(taxPayerAddress?.foreignCityName);
                }
                setTaxpayerAddress(taxPayerAddress);
                setFloorNo(taxPayerAddress?.floorNo);
                setFlatNo(taxPayerAddress?.flatNo);
                setBuildingNo(taxPayerAddress?.buildingNo);
                setStreetName(taxPayerAddress?.streetName);
                setStreetName2(taxPayerAddress?.streetName2);
                setAdditionalInformation(taxPayerAddress?.additionalInformation);
                setPostalCode(taxPayerAddress?.postalCode);
            }


        } catch (ex) {
            setChangeAddress(false);

        }
        setIsLoading(false);

    };


    const saveApplication = async () => {
        setIsSaving(true);
        setIsLoading(true);

        const valid = await form.Validate();
        if (valid) {
            try {
                const client = ServiceCreator.getProviderManagementPublicClient();
                const applicationDto = new SubmitApplicationRequestDto();
                applicationDto.email = email;
                applicationDto.mobileNo = mobileNo;
                applicationDto.url = url;
                applicationDto.activeFrom = UIHelpers.getUTCStartDate(activeFrom);
                applicationDto.activeTo = UIHelpers.getUTCEndDate(activeTo?? undefined) ?? undefined;
                applicationDto.applicationAttachments = applicationAttachments?.map(a => {
                    const newAttachment = new ApplicationAttachmentDto();
                    newAttachment.fileContentBase64 = a.fileContent;
                    newAttachment.fileName = a.fileName;
                    newAttachment.fileType = a?.fileType;
                    return newAttachment;

                }) ?? [];
                applicationDto.description = description;
                const addressDto = new AddressDto();
                addressDto.additionalInformation = additionalInformation;
                addressDto.countryID = countryID;
                addressDto.flatNo = flatNo;
                addressDto.streetName2 = streetName2;
                addressDto.streetName = streetName;
                addressDto.floorNo = floorNo;
                addressDto.buildingNo = buildingNo;
                addressDto.postalCode = postalCode;
                applicationDto.address = addressDto;

                if (countryID !== Countries.Egypt) {
                    addressDto.foreignGovernorateName = foreignGovernorateName;
                    addressDto.foreignCityName = foreignCityName;
                } else {
                    addressDto.governorateID = governorateID;
                    addressDto.cityID = cityID;
                }
                addressDto.countryCode = (countryID === Countries.Egypt) ? 'EG' : 'Other';
                if (IsRenew) {
                    applicationDto.type = ApplicationTypes.Renewal;
                    applicationDto.intermediaryId = intermediaryId;
                } else {
                    applicationDto.type = ApplicationTypes.Initial;
                }

                await client.submitApplication(applicationDto);
                setBusinessErrors(undefined);
                setExceptionMessage(undefined);
                history.push('/TaxpayerProfile');


            } catch (ex) {
                handleException(ex);
                setChangeAddress(false);
            }
        }
        setIsLoading(false);
        setIsSaving(false);
    };




    const bytesToSize = (bytes: number): string => {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes === 0) return '0 Byte';
        const i = Math.floor(Math.floor(Math.log(bytes) / Math.log(1024)));
        // eslint-disable-next-line no-restricted-properties
        return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
    };
    const IsValidData = (address: GetTaxpayerAddressDto | AddressDto | undefined) => {

        if (address?.countryID !== 0 && ((address?.countryID === Countries.Egypt && address?.governorateID !== 0) ||
            ((address?.countryID !== Countries.Egypt && address?.foreignGovernorateName))) &&
            ((address?.countryID === Countries.Egypt && address?.cityID !== 0) ||
                (address?.countryID !== Countries.Egypt && address?.foreignCityName)) &&
            address?.streetName && address?.buildingNo) {

            setChangeAddress(true);
        }

    };

    const getTaxPayerInfo = async () => {
        try {

            setIsLoading(true);
            const client = ServiceCreator.getTaxpayerManagementPublicClient();
            const lookupsResponse = await client.config(currentLanguage.lang);
            const countries = lookupsResponse?.countries?.map<
                IComboBoxOption
            >((v) => {
                return {
                    key: v.id || 0,
                    text: `${v.name}` || '',
                    data: `${v.code}`
                };
            }) ?? [];
            setCities(lookupsResponse.cities ?? []);
            const cities = lookupsResponse?.cities?.map<
                IComboBoxOption
            >((v) => {
                return {
                    key: v.id || 0,
                    text: `${v.name}` || '',
                    data: `${v.code}`,

                };
            }) ?? [];
            const governorates = lookupsResponse?.governorates?.map<
                IComboBoxOption
            >((v) => {
                return {
                    key: v.id || 0,
                    text: `${v.name}` || '',
                    data: `${v.code}`
                };
            }) ?? [];


            setLookups({ countries, cities, governorates });


            if (currentTaxpayerProfile?.registrationNumber) {
                const response = await client.getCurrentTaxpayerDetails();
                if (!IsRenew) {
                    const mainBranch = response.taxpayerBranchs?.find(b => b.isMainBranch === true);
                    const taxPayerAddress = mainBranch?.address;

                    setTaxpayer(response);
                    setTaxpayerAddress(taxPayerAddress);
                    setemail(response.email);
                    setMobileNo(response.mobileNo);
                    IsValidData(taxPayerAddress);
                    if (taxPayerAddress) {
                        setCountryID(taxPayerAddress.countryID);
                        setGovernorateID(taxPayerAddress.governorateID);
                        setCityID(taxPayerAddress.cityID);
                        setFloorNo(taxPayerAddress.floorNo);
                        setFlatNo(taxPayerAddress.flatNo);
                        setBuildingNo(taxPayerAddress.buildingNo);
                        setStreetName2(taxPayerAddress.streetName2);
                        setAdditionalInformation(taxPayerAddress.additionalInformation);
                        setPostalCode(taxPayerAddress.postalCode);
                        setForeignGovernorateName(taxPayerAddress.foreignGovernorateName);
                        setForeignCityName(taxPayerAddress.foreignCityName);
                        setStreetName(taxPayerAddress?.streetName);

                    } else {
                        const address = mainBranch?.sourceAddress;
                        setSourceAddress(address);
                        setStreetName(address);
                        setChangeAddress(false);

                    }

                } else if (response?.id) {
                    await getIntermideary(lookupsResponse);
                }

                dispatchChangeBreadcrumb([
                    {
                        key: 'taxpayerName',
                        text: (currentLanguage?.lang === 'en' ?
                            response?.namePrimaryLang :
                            response?.nameSecondaryLang) ?? ''
                        ,
                        onClick: () => {
                            history.push('/TaxpayerProfile');
                        },
                    },

                    {

                        key: 'registerIntermediary',
                        text: isApplied ? t('renewIntermediary') : t('registerIntermediary'),
                        isCurrentItem: true,
                    },
                ]);



            } else {
                history.push('/TaxpayerProfile');
            }


        } catch (ex) {
            handleException(ex);
        }
        setIsLoading(false);

    };
    const getFormatedAddress = () => {
        return (currentLanguage?.lang === 'en' ?
            taxpayerAddress?.formattedAddressEn :
            taxpayerAddress?.formattedAddressAr);
    };


    const deleteItem = (index: number) => {

        const remainingApplicationAttachments = applicationAttachments.filter((_, i) => i !== index);
        setApplicationAttachments([...remainingApplicationAttachments]);

        if (applicationAttachments.length <= maxNumberOfFiles) {
            setFileError('');
        }
    };


    useEffect(() => {
        const newcities = allcities?.filter(c => c.parentCode === governorateCode);
        const cities = newcities?.map<
            IComboBoxOption
        >((v) => {
            return {
                key: v.id || 0,
                text: `${v.name}` || '',
                data: `${v.code}`,

            };
        }) ?? [];

        setLookups({ ...lookups, cities });


    }, [governorateCode]);

    const handleFileSelected = (selectedFile: FileInfo, index?: number) => {
        if (applicationAttachments.find(a => a.fileName === selectedFile?.file?.name)) {
            return;
        }
        const size = selectedFile?.file?.size ?? 0;
        const sizeLimit = size / 1024 / 1024;

        const sizeInMB = bytesToSize(size);


        if (!selectedFile.size) {
            setFileError(t('InvalidContent'));
            return;

        }
        if (!allowedExtensions.exec(selectedFile?.file?.name ?? '')) {
            setFileError(t('invalidFile'));
            return;
        }


        if (sizeLimit > MaxAttachmentLimitInMB) {
            setFileError(t('maxFileSize'));
            return;
        }




        try {
            setFileError('');
            const fileReader = new FileReader();

            fileReader.onload = () => {
                const result = fileReader.result as string;
                const contentArraybase64 = result.split('base64,');
                const content = contentArraybase64[1];
                const newapplicationAttachments = applicationAttachments?.slice() ?? [];
                newapplicationAttachments[index ?? 0] = { fileContent: content, fileSize: sizeInMB, fileType: selectedFile?.file?.type ?? '', fileName: selectedFile?.file?.name };
                setApplicationAttachments([...newapplicationAttachments]);

            };
            fileReader.readAsDataURL(selectedFile?.file ?? new Blob());
        } catch {
            setFileError(t('InvalidContent'));
        }
    };

    const setFileSelected = (item: ApplicationAttachment) => {
        if (item) {
            const content = _base64ToArrayBuffer(item?.fileContent);

            const blob = new Blob([content], { type: '*.*' });

            return {
                name: t('Content'),
                file: new File([blob], t('Content'), {
                    type: String(item.fileType),
                }),
                size: blob.size,
                url: 'url'
            };
        }
        return undefined;
    };

    const setupFormValidation = async () => {

        form.AddField('countryID',
            setCountryID,
            yup.number().typeError(t('countryIDRequired')).required(t('countryIDRequired')),
            countryID);

        form.AddField('governorateID',
            setGovernorateID,
            yup.number().when(['countryID'], {
                is: (countryIDValue) => {
                    return countryIDValue && parseInt(countryIDValue, 10) === Countries.Egypt;
                },
                then: yup.number().typeError(t('governorateIDRequired')).required(t('governorateIDRequired'))
            }),
            governorateID);

        form.AddField('cityID',
            setCityID,
            yup.number().when(['countryID'], {
                is: (countryIDValue) => {
                    return countryIDValue && parseInt(countryIDValue, 10) === Countries.Egypt;
                },
                then: yup.number().typeError(t('cityIDRequired')).required(t('cityIDRequired'))
            }),
            cityID);


        form.AddField('foreignGovernorateName',
            setForeignGovernorateName,
            yup.string().when(['countryID'], {
                is: (countryIDValue) => {
                    return countryIDValue && parseInt(countryIDValue, 10) !== Countries.Egypt;
                },
                then: yup.string().trim().required(t('foreignGovernorateNameRequired')).max(50, t('foreignGovernorateNameLength'))
            }),
            foreignGovernorateName);

        form.AddField('foreignCityName',
            setForeignCityName,
            yup.string().when(['countryID'], {
                is: (countryIDValue) => {
                    return countryIDValue && parseInt(countryIDValue, 10) !== Countries.Egypt;
                },
                then: yup.string().trim().required(t('foreignCityNameRequired')).max(50, t('foreignCityNameLength'))
            }),
            foreignCityName);


        form.AddField('additionalInformation',
            setAdditionalInformation,
            yup.string().trim().notRequired().max(500, t('additionalInformationLength')),
            additionalInformation);

        form.AddField('postalCode',
            setPostalCode,
            yup.string().trim().notRequired().max(50, t('postalCodeLength')),
            postalCode);


        form.AddField('mobileNo',
            setMobileNo,
            yup.string().trim().required(t('mobileRequired')).max(14, t('mobileNoLength')).min(13, t('mobileNoMinLength')),
            mobileNo);

        form.AddField('email',
            setemail,
            yup.string().trim().required(t('emailRequired')).max(40, t('emailLength')),
            email);

        form.AddField('url',
            seturl,
            yup.string().notRequired().trim().max(2000, t('urlLength')),
            url);

        form.AddField('description',
            setdescription,
            yup.string().trim().notRequired().max(200, t('descriptionLength')),
            description);

        form.AddField('streetName',
            setStreetName,
            yup.string().trim().required(t('streetNameRequired')).max(200, t('streetNameMaxLength')),
            streetName);

        form.AddField('streetName2',
            setStreetName2,
            yup.string().trim().notRequired().max(100, t('streetNameLength')),
            streetName2);

        form.AddField('buildingNo',
            setBuildingNo,
            yup.string().trim().required(t('buildingNoRequired')).max(50, t('buildingNoLength')),
            buildingNo);

        form.AddField('ActiveFrom',
            setActiveFrom,
            yup.date().typeError(t('activeFromMessage')).required(t('activeFromMessage')),
            activeFrom);


        form.AddField('ActiveTo',
            setActiveTo,
            yup.date().typeError(t('activeToMessage')).required(t('activeToMessage')),
            activeTo);

            
        await form.Validate('_');// update isValid

    };

    const onLoadData = async () => {
        setOnLoadDataComplete(false);

        await getTaxPayerInfo();
        setBusinessErrors(undefined);
        setExceptionMessage(undefined);

        setOnLoadDataComplete(true);
    };

    useEffect(() => {
        const gridColumns = [
            {
                key: 'fileName',
                name: t('fileName'),
                nameAsJsx: <span><Icon iconName='Page' className='fileIcon' />{t('fileName')}</span>,
                fieldName: 'fileName',
                minWidth: 100,
                maxWidth: 800,
                isResizable: true,
                isSorted: false,
                isSortedDescending: false,
                allowSorting: false,
                isRowHeader: true,
                onRender: (item: ApplicationAttachment) => {
                    return (
                        <span>
                            <ActionButton
                                onClick={() => {
                                    const content = _base64ToArrayBuffer(item?.fileContent);

                                    UIHelpers.OpenContentInNewTab(content, item.fileType ?? '');
                                }
                                }
                            >
                                {item?.fileName}
                            </ActionButton>
                        </span>
                    );
                },
            },
            {
                key: 'File Size',
                name: t('fileSize'),
                fieldName: 'fileSize',
                minWidth: 100,
                maxWidth: 300,
                isResizable: true,
                isSorted: false,
                isSortedDescending: false,
                allowSorting: false,
                isRowHeader: true,
            },
            {
                key: '',
                name: '',
                fieldName: '',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
                isSorted: false,
                isSortedDescending: false,
                allowSorting: false,
                isRowHeader: true,

                onRender: (item: ApplicationAttachment, index?: number) => {
                    return (
                        <div className="horizontal">
                            <span >
                                <FileSelector
                                    labels={{
                                        selectFile: t('common:BrowseFile'),
                                        chooseAnotherFile: t(
                                            'common:ChooseAnother'
                                        ),
                                        viewFile: t('common:view'),

                                        deleteFile: t('common:Delete'),
                                        downloadFile: t('common:Download'),

                                    }}

                                    onSelectFile={(
                                        selectedFile: FileInfo
                                    ) => {
                                        return handleFileSelected(
                                            selectedFile,
                                            index
                                        );
                                    }}

                                    onCancelUpload={() => {
                                        cancellationToken.current = true;
                                    }}
                                    selectedFile={
                                        setFileSelected(item)
                                    }
                                    onDeleteFile={
                                        () => deleteItem(index ?? 0)
                                    }
                                    onDownloadFile={() =>

                                        UIHelpers.downloadFile(
                                            _base64ToArrayBuffer(item?.fileContent),
                                            item.fileType ?? '',
                                            item.fileName ?? ''
                                        )
                                    }
                                    readonly={false}
                                    mode={FileSelectorMode.Menu}
                                    extensionFilter='.gif,.jpg,.jpeg,.png,.pdf,.tiff'


                                />
                            </span>
                        </div>
                    );
                },
            }
        ];

        setColumns(gridColumns);


    }, [t]);



    useEffect(() => {

        getTaxPayerInfo();

        form.ClearErrors();
        setBusinessErrors(undefined);
        setExceptionMessage(undefined);
    }, [t]);



    useEffect(() => {
        onLoadData();
    }, [t]);


    useEffect(() => {
        if (onLoadDataComplete) setupFormValidation();
    }, [t, onLoadDataComplete]);


    const handleNewFileSelected = (selectedFile: FileInfo) => {
        if (applicationAttachments.find(a => a.fileName === selectedFile?.file?.name)) {
            return;
        }
        const size = selectedFile?.file?.size ?? 0;
        const sizeLimit = size / 1024 / 1024;
        const sizeInMB = bytesToSize(size);



        if (!selectedFile.size) {
            setFileError(t('InvalidContent'));
            return;

        }

        if (!allowedExtensions.exec(selectedFile?.file?.name ?? '')) {
            setFileError(t('invalidFile'));
            return;
        }


        if (sizeLimit > MaxAttachmentLimitInMB) {
            setFileError(t('maxFileSize'));
            return;
        }

        if (applicationAttachments.length + 1 > maxNumberOfFiles) {
            setFileError(t('fileNumberError'));
            setTimeout(() => {
                setFileError('');
            }, 5000);
            return;
        }
        setFileError('');


        try {
            setFileError('');
            const fileReader = new FileReader();

            fileReader.onload = () => {
                const result = fileReader.result as string;
                const contentArraybase64 = result.split('base64,');
                const content = contentArraybase64[1];
                const newApplicationAttachment = new ApplicationAttachment();
                newApplicationAttachment.fileName = selectedFile?.file?.name;
                newApplicationAttachment.fileSize = sizeInMB;
                newApplicationAttachment.fileType = selectedFile?.file?.type ?? '';
                newApplicationAttachment.fileContent = content;
                const newapplicationAttachments = applicationAttachments?.slice() ?? [];
                newapplicationAttachments.push(newApplicationAttachment);
                setApplicationAttachments([...newapplicationAttachments]);



            };
            fileReader.readAsDataURL(selectedFile?.file ?? new Blob());


        } catch {
            setFileError(t('InvalidContent'));
        }
    };

    return (
        <LayoutContent className={clsx('manageApplicaton', inputsClassName)} loading={isLoading}>

            {
                (businessErrors || exceptionMessage) && (
                    <MessageBar messageBarType={MessageBarType.blocked} isMultiline
                        onDismiss={() => {
                            setBusinessErrors(undefined);
                            setExceptionMessage(undefined);
                        }}
                    >
                        {
                            exceptionMessage?.toString() ?? businessErrors ?? ''}
                    </MessageBar>
                )
            }
            <div className="panel" >
                <div className="headerApplicaton">
                    {true && (
                        <div className="editable">
                            {/* <IconButton title={t('edit')} ariaLabel={t('edit')}/> */}
                            <div className="main_header">
                                <Section title={isApplied ? t('renewApplication') : t('registerApplication')} size={SectionSize.h2} />
                            </div>
                        </div>
                    )}
                </div>
                <div className="header_section" >
                    <div className="title">
                        <Section title={t('taxpayerDetails')} size={SectionSize.h2} />
                    </div>
                </div>
                <div className='containerApplicaton'>
                    <div className="bodyApplicaton">
                        {(changeAddress) && (
                            <div className='btn-change'>
                                <ActionButton iconProps={pencilIcon} className='ms-pencilIcon' onClick={() => setChangeAddress(false)}>{t('change')}</ActionButton>
                            </div>
                        )}
                        <TextField label={t('taxpayerName')}
                            className='name'
                            value={currentLanguage?.lang === 'en' ?
                                taxpayer?.namePrimaryLang :
                                taxpayer?.nameSecondaryLang}
                            readOnly
                        />
                        {!changeAddress ? (
                            // eslint-disable-next-line react/jsx-fragments
                            <Fragment>
                                <VirtualizedComboBox
                                    multiSelectDelimiter=''
                                    selectedKey={countryID}
                                    autoComplete="on"
                                    required
                                    options={lookups?.countries ?? []}
                                    label={t('country')}
                                    onChange={(_e, option) => {
                                        form.UpdateField('countryID', option ? Number(option.key) : undefined);
                                    }
                                    }
                                    errorMessage={form?.errors?.countryID ?? ''}
                                />
                                {countryID === Countries.Egypt ? (
                                    <VirtualizedComboBox
                                        multiSelectDelimiter=''

                                        selectedKey={governorateID}
                                        autoComplete="on"
                                        required
                                        options={lookups?.governorates ?? []}
                                        label={t('governorate')}
                                        onChange={(_e, option) => {
                                            form.UpdateField('governorateID', option ? Number(option.key) : undefined);
                                            setgovernorateCode(option?.data);
                                        }
                                        }
                                        errorMessage={form?.errors?.governorateID ?? ''}
                                    />
                                )
                                    : (
                                        <TextField
                                            label={t('governorate')}
                                            value={foreignGovernorateName}
                                            required
                                            onChange={(e, val) => form.UpdateField('foreignGovernorateName', val)}
                                            errorMessage={form?.errors?.foreignGovernorateName ?? ''}
                                        />
                                    )
                                }
                                {countryID === Countries.Egypt ? (
                                    <VirtualizedComboBox
                                        multiSelectDelimiter=''

                                        selectedKey={cityID}
                                        autoComplete="on"
                                        required
                                        options={lookups?.cities ?? []}
                                        label={t('city')}
                                        onChange={(e, option) => form.UpdateField('cityID', option ? Number(option.key) : undefined)}
                                        errorMessage={form?.errors?.cityID ?? ''}
                                    />
                                )
                                    : (
                                        <TextField
                                            label={t('city')}
                                            value={foreignCityName}
                                            required
                                            onChange={(e, val) => form.UpdateField('foreignCityName', val)}
                                            errorMessage={form?.errors?.foreignCityName ?? ''}
                                        />
                                    )
                                }

                            </Fragment>
                        ) : (
                            <TextField
                                className='formatedAddressApp'
                                label={t('formatedAddress')}
                                value={
                                    taxpayerAddress?.formattedAddressEn ? getFormatedAddress() : sourceAddress ?? intermidearyAddress ?? ''}
                                readOnly
                            />
                        )
                        }
                    </div>

                    {!changeAddress &&
                        (
                            // eslint-disable-next-line react/jsx-fragments
                            <Fragment>
                                <div className="bodyApplicaton">
                                    <div>
                                        <TextField
                                            label={t('buildingNo')}
                                            value={buildingNo}
                                            required
                                            onChange={(e, val) => form.UpdateField('buildingNo', val)}
                                            errorMessage={form?.errors?.buildingNo ?? ''}
                                        />
                                    </div>
                                    <div className='flat_details'>
                                        <TextField label={t('floorNo')}
                                            value={floorNo}
                                            onChange={(e, val) => setFloorNo(val)}

                                        />
                                        <TextField label={t('flatNo')}
                                            value={flatNo}
                                            onChange={(e, val) => setFlatNo(val)}
                                            errorMessage={form?.errors?.flatNo ?? ''}
                                        />
                                    </div>
                                </div>

                                <div className="bodyApplicaton">
                                    <TextField
                                        label={t('streetName')}
                                        required
                                        value={streetName}
                                        onChange={(e, val) => form.UpdateField('streetName', val)}
                                        errorMessage={form?.errors?.streetName ?? ''}
                                    />
                                    <TextField label={t('streetName2')}
                                        value={streetName2}
                                        onChange={(e, val) => form.UpdateField('streetName2', val)}
                                        errorMessage={form?.errors?.streetName2 ?? ''}
                                    />
                                </div>

                                <div className="bodyApplicaton">
                                    <div>
                                        <TextField
                                            label={t('additionalInformation')}
                                            value={additionalInformation}
                                            onChange={(e, val) => form.UpdateField('additionalInformation', val)}
                                            errorMessage={form?.errors?.additionalInformation ?? ''}

                                        />
                                    </div>
                                    <div className='postalCode'>
                                        <TextField label={t('postalCode')}
                                            value={postalCode}
                                            onChange={(e, val) => form.UpdateField('postalCode', val)}
                                            errorMessage={form?.errors?.postalCode ?? ''}

                                        />
                                    </div>
                                </div>
                            </Fragment>
                        )}
                    <div className="bodyApplicaton">
                        <div className='email_mobile'>
                            <TextField
                                label={t('email')}
                                value={email}
                                onChange={(e, val) => form.UpdateField('email', val)}
                                errorMessage={form?.errors?.email ?? ''}
                                required
                            />
                            <TextField label={t('mobileNo')}
                                value={mobileNo}
                                onChange={(e, val) => form.UpdateField('mobileNo', val)}
                                errorMessage={form?.errors?.mobileNo ?? ''}
                                required
                                className="mobilePhoneField"
                            />
                        </div>
                        <div />
                    </div>

                    <div className="header_section" >
                        <div className="title">
                            <Section title={t('application')} size={SectionSize.h2} />
                        </div>
                    </div>

                    <div className="bodyApplicaton">
                        <TextField
                            label={t('url')}
                            value={url}
                            onChange={(e, val) => form.UpdateField('url', val)}
                            errorMessage={form?.errors?.url ?? ''}
                            placeholder={t('urlPlaceholder')}

                        />
                    </div>

                    <div className="bodyApplicaton">
                        <div className='DatePicker'>
                            <div>
                                <DatePicker label={t('activeFrom')}
                                    value={activeFrom}
                                    firstWeekOfYear={1}
                                    showMonthPickerAsOverlay
                                    onSelectDate={(val) => form.UpdateField('ActiveFrom', val)}
                                    formatDate={(date) => { return UIHelpers.FormatDatePickerValue(date, currentLanguage?.langIso4); }}
                                    isRequired
                                    allowTextInput
                                    parseDateFromString={UIHelpers.ParseDatePickerString}
                                    minDate={today}
                                />
                                <span>{form?.errors?.ActiveFrom && <span className='errorMsg'>{form?.errors?.ActiveFrom}</span>}</span>
                            </div>
                            <div>
                                <DatePicker label={t('activeTo')} value={activeTo ?? undefined}
                                    onSelectDate={(val) => form.UpdateField('ActiveTo', val)}
                                    firstWeekOfYear={1}
                                    showMonthPickerAsOverlay
                                    isRequired
                                    allowTextInput
                                    formatDate={(date) => { return UIHelpers.FormatDatePickerValue(date, currentLanguage?.langIso4); }}
                                    parseDateFromString={UIHelpers.ParseDatePickerString}
                                    minDate={activeFrom}
                                />
                                {form?.errors?.ActiveTo && <span className='errorMsg'>{form?.errors?.ActiveTo}</span>}
                            </div>
                        </div>
                        <div>
                            <TextField
                                label={t('description')}
                                value={description}
                                onChange={(e, val) => form.UpdateField('description', val)}
                                errorMessage={form?.errors?.description ?? ''}


                            />
                        </div>
                    </div>
                    <div className='attachment'>
                        <div className='flex_content'>
                            <div className="header_sectionGrid" >
                                <div className="title">
                                    <div className='eta-section'>
                                        <div className='header'>
                                            <h2>{`${t('attatchment')}`} <span className='sub_attachment'>{`(${applicationAttachments.length}/10 ${t('fileLimit')})`}</span></h2>
                                            <div className='space' />
                                        </div>
                                        <div className='lineSeparator' />
                                    </div>

                                    {fileError && <div className="errorMsg">{fileError}</div>}
                                </div>
                            </div>
                            <div className='fileSelector-attachment'>
                                <FileSelector
                                    labels={{
                                        selectFile: t('add'),

                                    }}
                                    onSelectFile={(
                                        selectedFile: FileInfo
                                    ) => {
                                        handleNewFileSelected(
                                            selectedFile

                                        );
                                    }}
                                    mode={FileSelectorMode.Button}

                                    extensionFilter='.gif,.jpg,.jpeg,.png,.pdf,.tiff'

                                    readonly={false}
                                />
                            </div>
                        </div>

                        <DetailsList
                            className="grid"
                            columns={columns ?? []}
                            items={applicationAttachments}
                            shimmerLines={NumberOfShimmerLines}
                            enableShimmer={!applicationAttachments}
                            layoutMode={DetailsListLayoutMode.justified}
                            selectionMode={SelectionMode.none}
                            labels={{
                                resultPerPage: t('common:nbItemPerPage'),
                                totalRecord: t('common:totalRecord'),
                            }}
                            noItemsPlaceholder={t('NOShowMsg')}

                        />
                    </div>

                    <div className="btnManageApplicaton">
                        <PrimaryButton className='first' iconProps={{ iconName: 'Cancel' }} text={t('cancel')}
                            onClick={() => history.push('/TaxpayerProfile')} />

                        {!IsRenew && (
                            <PrimaryButton className='second' iconProps={{ iconName: 'CheckMark' }} text={t('register')}
                                onClick={() => saveApplication()} disabled={!isValid || isSaving}>
                                {isSaving && <Spinner size={SpinnerSize.small} />}
                            </PrimaryButton>
                        )}

                        {IsRenew && (
                            <PrimaryButton className='second' iconProps={{ iconName: 'Redo' }} text={t('renew')}
                                onClick={() => saveApplication()} disabled={!isValid || isSaving}>
                                {isSaving && <Spinner size={SpinnerSize.small} />}
                            </PrimaryButton>
                        )}


                    </div>
                </div>
            </div>


        </LayoutContent >
    );

};
export default connector(Application);


